// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
/// <summary>
/// Буфер маркеров для серий индикаторов
/// </summary>
export class MarkersVector {
    constructor() {
        this.markers = {}; // new Dictionary<int, Color>();
        this.counter = 0;
    }
    /// <summary>
    /// Добавление пустого маркера в буфер
    /// </summary>
    Add() {
        this.counter++;
    }
    /// <summary>
    /// Очистка буфера
    /// </summary>
    Clear() {
        this.markers = {};
        // подумать
        this.counter = 0;
    }
    SetMarker(offset, color) {
        this.markers[offset] = color;
    }
    RemoveMarker(offset) {
        this.markers[offset] = null;
    }
    ClearMarkers() {
        this.markers = {};
        // подумать
        this.counter = 0;
    }
    getColor(index) {
        const color = this.markers[index];
        if (color) {
            return color;
        }
        else {
            return null;
        }
    }
    get Count() {
        return this.counter;
    }
}
